// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"5":"2b406f5a","125":"2b406f5a","161":"b3bd0cd0","286":"3881016a","502":"2b406f5a"}[chunkId] + ".css";
};